import React from 'react';

const Chapter = () => (
  <section className="chapters">
    <div className="current-chapter">
      <span className="current-chapter-one">CURRENT CHAPTER</span>
      <span className="current-chapter-two">Chapter IV</span>
    </div>
    <button type="button">UPDATE PROGRESS</button>
  </section>
);

export default Chapter;
